import { Badge, type BadgeProps } from '@/components/ui/badge';
import type { TenantStatus } from '@/lib/tenants-api';

export const TENANT_STATUS_LABELS: Record<TenantStatus, string> = {
  ACTIVE: 'Actif',
  TRIAL: 'Essai',
  SUSPENDED: 'Suspendu',
  CANCELLED: 'Annulé',
};

const VARIANTS: Record<TenantStatus, BadgeProps['variant']> = {
  ACTIVE: 'success-soft',
  TRIAL: 'warning-soft',
  SUSPENDED: 'danger-soft',
  CANCELLED: 'muted-soft',
};

export const TenantStatusBadge = ({ status }: { status: TenantStatus }) => (
  <Badge variant={VARIANTS[status]} data-testid="tenant-status">
    {TENANT_STATUS_LABELS[status]}
  </Badge>
);
